import { cn } from '@/lib/utils';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const separatorVariants = cva('', {
  variants: {
    orientation: {
      horizontal: '',
      vertical: '',
    },
    thickness: {
      sm: '',
      md: '',
      lg: '',
    },
    variant: {
      default: 'bg-border',
      muted: 'bg-muted',
      destructive: 'bg-destructive',
    },
  },
  compoundVariants: [
    { orientation: 'horizontal', thickness: 'sm', className: 'h-px w-full' },
    { orientation: 'horizontal', thickness: 'md', className: 'h-[1.5px] w-full' },
    { orientation: 'horizontal', thickness: 'lg', className: 'h-[2px] w-full' },
    { orientation: 'vertical', thickness: 'sm', className: 'w-px h-full' },
    { orientation: 'vertical', thickness: 'md', className: 'w-[1.5px] h-full' },
    { orientation: 'vertical', thickness: 'lg', className: 'w-[2px] h-full' },
  ],
  defaultVariants: {
    orientation: 'horizontal',
    thickness: 'md',
    variant: 'default',
  },
});

type SeparatorProps = React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> &
  VariantProps<typeof separatorVariants>;

const Separator = ({
  className,
  orientation = 'horizontal',
  decorative = true,
  variant,
  thickness,
  ...props
}: SeparatorProps) => {
  return (
    <SeparatorPrimitive.Root
      decorative={decorative}
      orientation={orientation}
      className={cn(
        separatorVariants({
          orientation,
          variant,
          thickness,
        }),
        className,
      )}
      {...props}
    />
  );
};

export { Separator };
